import { SxProps } from "@mui/material";
import { getWidthChart, getHeightChart } from "../utils/stylesUtils";
import useFiltersStore from '../store/filtersStore';
import { FilterState } from "../types/types";

export const chartContainerBodyH= (filters: FilterState, labelsCount: number): SxProps => {

    return {
        height: {xs: "calc(70vh - 80px)", sm: "calc(70vh - 80px)", md: "calc(70vh - 80px)", lg: "calc(75vh - 80px)", xl: "calc(82vh - 80px)"},
        width: getWidthChart(filters, labelsCount),
        overflowY: 'scroll',
        overflow: 'scroll',
        marginRight: '10px',
        // display: (filters?.orientation === 'x') ? '' : 'none'
    }
};    

export const chartContainerBodyV = (filters: FilterState, labelsCount: number): SxProps => {

    const styleChart = getHeightChart(filters, labelsCount);
    const overflow = styleChart.overflow;
    return {
        height: overflow === 'scroll' ? "100%" : {xs: "calc(70vh - 80px)", sm: "calc(70vh - 80px)", md: "calc(80vh - 80px)", lg: "calc(75vh - 80px)", xl: "calc(82vh - 80px)"},
        width:  '97vw',
        overflowY: overflow,
        msOverflowX: 'hidden',
        marginRight: '0px',
        // display: (filters?.orientation === 'y') ? '' : 'none'
    };
    // height: "100%",
    // width:  '97vw',
    // overflow: 'scroll',
    // marginRight: '0px',
}